import { c as _c } from "react/compiler-runtime";
import useOS from './hooks/use-os';
export type ShortcutHintProps = {
  keys: string[];
};
const MAC_KEY_SYMBOLS: Record<string, string> = {
  enter: '↩',
  return: '↩',
  control: 'Ctrl',
  ctrl: 'Ctrl',
  alt: '⌥',
  option: '⌥',
  shift: '⇧',
  command: '⌘',
  cmd: '⌘',
  meta: '⌘',
  mod: '⌘',
  esc: 'Esc',
  escape: 'Esc',
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
  tab: '⇥',
  backspace: '⌫',
  delete: '⌦',
  space: '␣',
  slash: '/'
};
const WINDOWS_KEY_SYMBOLS: Record<string, string> = {
  enter: 'Enter',
  return: 'Enter',
  control: 'Ctrl',
  ctrl: 'Ctrl',
  alt: 'Alt',
  option: 'Alt',
  shift: 'Shift',
  command: 'OS',
  cmd: 'OS',
  meta: 'OS',
  mod: 'Ctrl',
  esc: 'Esc',
  escape: 'Esc',
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
  tab: 'Tab',
  backspace: 'Backspace',
  delete: 'Delete',
  space: 'Space',
  slash: '/'
};
const ShortcutHint = t0 => {
  const $ = _c(9);
  const {
    keys
  } = t0;
  const os = useOS();
  const isMacOs = os === "mac";
  const keySymbols = isMacOs ? MAC_KEY_SYMBOLS : WINDOWS_KEY_SYMBOLS;
  let t1;
  let t2;
  if ($[0] !== keySymbols || $[1] !== keys) {
    let t3;
    if ($[4] !== keySymbols) {
      t3 = key => keySymbols[key.toLowerCase()] || key.toUpperCase();
      $[4] = keySymbols;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const displayKeys = keys.map(t3);
    t1 = "whitespace-nowrap text-quaternary text-caption-1";
    t2 = displayKeys.join(" + ");
    $[0] = keySymbols;
    $[1] = keys;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ShortcutHint;